import toast from 'react-hot-toast';
import { postRequest } from '../services/apiMethods';
import { useMutation } from '@tanstack/react-query';

const useModifyVendorStatus = () => {
  const { mutate: changeVendorLikeStatus, isLoading: apiState } = useMutation({
    mutationFn: ({ id, status }) => {
      const modifyData = {
        vendorId: id,
        status: status,
      };
      return postRequest(`/lead/favourite/vendor`, modifyData);
    },
    onSuccess: (data) => {
      // toast.success(`${data?.message}`, {
      //   iconTheme: {
      //     primary: '#337FE0',
      //     secondary: '#FFFAEE',
      //   },
      // });
      window.location.reload()
    },
    onError: (error) => {
      console.error('Error during API call:', error);
    },
  });

  return {changeVendorLikeStatus, apiState };
};

export default useModifyVendorStatus;
